import { render, staticRenderFns } from "./file-attach.vue?vue&type=template&id=8ea3b3b0&scoped=true"
import script from "./file-attach.vue?vue&type=script&lang=js"
export * from "./file-attach.vue?vue&type=script&lang=js"
import style0 from "./file-attach.vue?vue&type=style&index=0&id=8ea3b3b0&prod&scoped=true&lang=css"
import style1 from "./file-attach.vue?vue&type=style&index=1&id=8ea3b3b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea3b3b0",
  null
  
)

export default component.exports